import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import template from '../../screens/HR/HRAdmin/template_additionalperiods.docx';
import template_noAdditional from '../../screens/HR/HRAdmin/template_noAdditionalPeriod.docx';
import tempate_englishgreek from '../../screens/HR/HRAdmin/template_englishgreekschool.docx';
import template_englishgreek_noAdditional from '../../screens/HR/HRAdmin/template_englishgreekschool_noAdditional.docx';



const readTemplateFile = async (file) => {
  try {
    const response = await fetch(file)
    const arrayBuffer = await response.arrayBuffer();
    return arrayBuffer;
  } catch (error) {
    console.error('Error reading template file:', error);
    return null;
  }
};

// * Function to export data to Word
export const exportToWord = async (data, title, school) => {
  // *Load the template
  const templateAdditional = await readTemplateFile(template);
  const templateNoAdditional = await readTemplateFile(template_noAdditional)
  const tempateEnglishGreek = await readTemplateFile(tempate_englishgreek)
  const tempateEnglishGreekNoAdditional = await readTemplateFile(template_englishgreek_noAdditional)
  const outputZip = new JSZip();

  if (!templateAdditional || !templateNoAdditional) {
    console.error('Template file not found');
    return;
  }

  const startsWithVowel = (str) => {
    // Regular expression to match vowels at the beginning of the string
    const vowelRegex = /^[aeiouAEIOU]/;
    return vowelRegex.test(str);
  }

  // returns true if seniority will also be shown alongside jobtitle (aka if both jobtitle & seniority contain 'teacher', then do not 
  // show)
  const showSeniority = (emplJobTitle, emplSeniority) => {
    let jobTitle = emplJobTitle?.toLowerCase();
    let seniority = emplSeniority?.toLowerCase();

    if (!emplJobTitle || !emplSeniority) return true;

    if (jobTitle === seniority) return false;

    if (jobTitle.includes('teacher') && seniority.includes('teacher')) return false;

    return true;
  };
  // * Loop through all the data 
  console.log(data)
  data.map((dItr) => {
    let zip = undefined;
    if (dItr.emplContext === 'CEBI' || dItr.emplContext === 'NCEBI' || dItr.emplContext === 'CGO' || dItr.emplContext === 'NCGO') {
      if (dItr.additionalTotalAM === 0 && dItr.additionalTotalPM === 0) {
        zip = new PizZip(tempateEnglishGreekNoAdditional);
      }
      else
        zip = new PizZip(tempateEnglishGreek);
    }
    else {
      if (dItr.additionalTotalAM === 0 && dItr.additionalTotalPM === 0) {
        zip = new PizZip(templateNoAdditional);
      }
      else
        zip = new PizZip(templateAdditional);
    }
    const doc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true,
    });
    doc.setData({
      name: dItr.employeeName, emplId: dItr.emplResPermitNumber === '' ? dItr.emplPassport === '' ? dItr.employeeNum : dItr.emplPassport : dItr.emplResPermitNumber,
      jobtitle: startsWithVowel(dItr.emplJobTitle) ? 'an ' + dItr.emplJobTitle : 'a ' + dItr.emplJobTitle, seniority: !showSeniority(dItr.emplJobTitle, dItr.emplSeniority) ? '' : ' and ' + dItr.emplSeniority,
      year: dItr.year, company: title,
      totalperweek: dItr.morningPeriodsTotals + dItr.afternoonPeriodsTotals, additionalperweek: dItr.additionalTotalPM + dItr.additionalTotalAM, totalteachingperiods: dItr.morningPeriodsTotals + dItr.afternoonPeriodsTotals + dItr.additionalTotalPM + dItr.additionalTotalAM,
      approverName: dItr.approverName, additionalCompany: dItr.secondarySchool, additionalDesc: dItr.additionalDesc.replace(/,([^,]*)$/, '$1'),
      min: dItr.min, cardIdentifier: dItr.cardIdentifier
    });

    try {
      doc.render();
      const content = doc.getZip().generate({ type: 'blob' });
      const filename = `${dItr.employeeName}.docx`;
      outputZip.file(filename, content);
    } catch (error) {
      console.error('Docx generation failed', error);
    }
  })
  // Generate the ZIP file and trigger download
  const zipBlob = await outputZip.generateAsync({ type: 'blob' });
  saveAs(zipBlob, `${title}.zip`);
};

